const SDK_VERSION = '7.65.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
